import { render, staticRenderFns } from "./viewWorks.vue?vue&type=template&id=66e3fe66&scoped=true"
import script from "./viewWorks.vue?vue&type=script&lang=js"
export * from "./viewWorks.vue?vue&type=script&lang=js"
import style0 from "./viewWorks.vue?vue&type=style&index=0&id=66e3fe66&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e3fe66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66e3fe66')) {
      api.createRecord('66e3fe66', component.options)
    } else {
      api.reload('66e3fe66', component.options)
    }
    module.hot.accept("./viewWorks.vue?vue&type=template&id=66e3fe66&scoped=true", function () {
      api.rerender('66e3fe66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/works/viewWorks.vue"
export default component.exports